var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-light-blue"},[_c('Bgcontainer'),_c('router-view',{key:_vm.$route.fullPath}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }